import view from './view.js';

export { view };



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/index.js